// extracted by mini-css-extract-plugin
module.exports = {"reportHealthRiskDetails":"MarkerClusterComponent_reportHealthRiskDetails__IpslC","popup":"MarkerClusterComponent_popup__1ypUT"};